<template src='./VerListadoCategorias.html'></template>
<script>
import { serverBus } from "../../main";
import VerTarjetaMiniatura from "../VerTarjetaMiniatura/VerTarjetaMiniatura";
export default {
  data() {
    return {
      verCategoria: "",
      banderaFormulariosLlenosTipoMomento: false,
      formularios: [],
      accordion: true,
      focusable: true,
      banderaVerCategoria: false,
      panel: [],
      clicked: false
    };
  },
  beforeUpdate() {

  },
  created() {

  },
  mounted() {
    // serverBus.$on("verCategoriaFormularioAcordeon", nombreCategoria => {
    //   this.formulariosLlenosTipoMomentoAcordeon = [];
    //   this.consultarResumenEncuentrosPorTipoAcordeon(nombreCategoria);
    // });
  },
  computed: {
    getConsultarEncuentro() {
      if (this.$store.getters.getConsultarEncuentro != null && this.banderaVerCategoria === false) {
        this.panel = this.formulariosMomentosllenos.indexOf(this.formulariosMomentosllenos.filter(elemento => elemento.nombre == this.verCategoria)[0]
        );
      }
      return this.$store.getters.getConsultarEncuentro;
    }
  },
  watch: {
    getConsultarEncuentro() {}
  },
  props: {
    formulariosMomentosllenos: {
      type: Array,
      required: true
    },
    formulariosLlenosTipoMomento: {
      required: true
    },
    banderaOcultarMas: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  components: {
    VerTarjetaMiniatura
  },
  methods: {
    agregarFormulario(nombreFormulario) {
      this.$store.dispatch("setVariablesFormulariosOverlay", []);
      if (this.clicked) {
        return false;
      }
      this.clicked = true;
      this.$store.dispatch("setNombreFormularioOverlay", nombreFormulario);
      this.$store.dispatch("setBanderaBotonMasOverlay", true);
      serverBus.$emit("crearFormularioNuevo");
      setTimeout(function(){
        this.clicked = false;
      }.bind(this), 500);
    },
    verCategoriaFormulario: function(nombreCategoria,coleccion) {
      this.banderaVerCategoria = true;

      // this.$emit("coleccion", this.coleccion);
      serverBus.$emit("verCategoriaFormularioOverlay", nombreCategoria,coleccion);
    }
  }
};
</script>
<style src='./VerListadoCategorias.scss' lang="scss" scoped>
</style>




// WEBPACK FOOTER //
// src/components/VerListadoCategorias/VerListadoCategorias.vue